import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import { Icon } from 'antd';
import { getIconForStatus } from '../utils';
import HowToFix from '../shared/HowToFix';

export default function FaviconSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <FaviconResult
                    url={hasCompetitors ? url : undefined}
                    status={result.status}
                    message={result.message}
                    faviconUrl={result.favicon_url}
                />

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => (
                            <div className="description-content">
                                <ul>
                                    <li>
                                        {result.favicon_url && (
                                            <div className="favicon-image">
                                                <img
                                                    src={result.favicon_url}
                                                    alt="favicon"
                                                />
                                            </div>
                                        )}
                                        {result.message}
                                    </li>
                                </ul>
                            </div>
                        )}
                        hideMessage={true}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type FaviconResultProps = {
    url?: string;
    status: string;
    message: string;
    faviconUrl?: string;
};

function FaviconResult({ url, status, faviconUrl, message }: FaviconResultProps) {
    return (
        <div className="description-content">
            {url && (
                <div className="flexbox align-center">
                    <Icon
                        type={getIconForStatus(status)}
                        theme="filled"
                        className="status-icon"
                    />
                    <span className="section-result-url">{url}</span>
                </div>
            )}
            <ul>
                <li>
                    {faviconUrl && (
                        <div className="favicon-image">
                            <img
                                src={faviconUrl}
                                alt="favicon"
                            />
                        </div>
                    )}
                    {message}
                </li>
            </ul>
        </div>
    );
}
